(function () {
  'use strict';

  // Preview request continuity.
  //
  // This store's primary domain is not served by Shopify yet. In an active
  // Shopify preview a request that carries the preview request parameters is
  // rendered in place, while the same path without them answers with the
  // primary-domain redirect and leaves the preview. Theme scripts build their
  // own relative request URLs (the variant picker's section re-render, cart and
  // recommendation sections), so without this wrapper a selection change never
  // reaches the server and the page silently keeps the previous variant.
  //
  // This wrapper re-applies only the preview parameters that are ALREADY
  // present in the current URL. It never creates them, so a production page
  // (no preview parameters, no design mode) never activates it and never gains
  // a parameter. Only same-origin, bodiless GET requests are decorated; every
  // other request is passed through untouched.

  var PRESERVE_KEYS = ['preview_theme_id', '_fd'];
  var PREVIEW_VALUE = /^[0-9]+$/;
  var BLOCKED_PATH = /^\/(?:checkout|account|admin|services|cdn|cdn-cgi|payments?|preferences|password)(?:\/|$)/i;
  var ASSET_PATH = /\.(?:png|jpe?g|gif|webp|avif|svg|ico|css|js|mjs|map|json|xml|txt|pdf|zip|csv|woff2?|ttf|otf|eot|mp4|webm|mp3|wasm)(?:$|[?#])/i;
  var ABSOLUTE_URL = /^[a-zA-Z][a-zA-Z0-9+.-]*:/;

  function hasOwn(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
  }

  function previewParams(search) {
    var out = {};
    var params;
    try {
      params = new URLSearchParams(search || '');
    } catch (error) {
      return out;
    }
    for (var index = 0; index < PRESERVE_KEYS.length; index++) {
      var key = PRESERVE_KEYS[index];
      var value = params.get(key);
      if (value !== null && PREVIEW_VALUE.test(value)) out[key] = value;
    }
    return out;
  }

  function hasPreviewParams(params) {
    for (var key in params) {
      if (hasOwn(params, key)) return true;
    }
    return false;
  }

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode === true);
  }

  function isPreviewActive() {
    return isDesignMode() || hasPreviewParams(previewParams(window.location.search));
  }

  function methodOf(input, init) {
    if (init && typeof init.method === 'string' && init.method !== '') return init.method.toUpperCase();
    if (typeof Request === 'function' && input instanceof Request && typeof input.method === 'string') {
      return input.method.toUpperCase();
    }
    return 'GET';
  }

  function hasBody(input, init) {
    if (init && init.body !== undefined && init.body !== null) return true;
    if (typeof Request === 'function' && input instanceof Request && input.body !== null) return true;
    return false;
  }

  function urlOf(input) {
    if (typeof input === 'string') return input;
    if (typeof URL === 'function' && input instanceof URL) return input.href;
    if (typeof Request === 'function' && input instanceof Request) return input.url;
    return null;
  }

  // Returns the decorated URL, or null when the request must be passed through
  // unchanged (no preview state, foreign origin, blocked or asset path, or
  // already carrying every preserved parameter).
  function decorate(rawUrl, params) {
    if (typeof rawUrl !== 'string' || rawUrl === '') return null;
    if (!hasPreviewParams(params)) return null;
    var base, target;
    try {
      base = new URL(window.location.href);
      target = new URL(rawUrl, window.location.href);
    } catch (error) {
      return null;
    }
    if (target.protocol !== 'http:' && target.protocol !== 'https:') return null;
    if (target.origin !== base.origin) return null;
    if (BLOCKED_PATH.test(target.pathname)) return null;
    if (ASSET_PATH.test(target.pathname)) return null;
    var changed = false;
    for (var key in params) {
      if (!hasOwn(params, key)) continue;
      if (target.searchParams.has(key)) continue;
      target.searchParams.set(key, params[key]);
      changed = true;
    }
    if (!changed) return null;
    return ABSOLUTE_URL.test(rawUrl) ? target.href : target.pathname + target.search + target.hash;
  }

  function install() {
    try {
      if (!isPreviewActive()) return;
      if (typeof window.fetch !== 'function') return;
      var original = window.fetch;
      window.fetch = function (input, init) {
        try {
          if (methodOf(input, init) === 'GET' && !hasBody(input, init)) {
            var raw = urlOf(input);
            var next = decorate(raw, previewParams(window.location.search));
            if (next !== null) {
              if (typeof Request === 'function' && input instanceof Request) {
                return original.call(this, new Request(next, input));
              }
              return original.call(this, next, init);
            }
          }
        } catch (error) {
          // Fall through to the untouched request.
        }
        return original.call(this, input, init);
      };
      api.installed = true;
    } catch (error) {
      // Stay inert rather than risk any production request.
    }
  }

  var api = {
    preserveKeys: PRESERVE_KEYS.slice(),
    previewParams: previewParams,
    decorate: decorate,
    isPreviewActive: isPreviewActive,
    installed: false
  };

  window.AccioTeakPreviewFetch = api;

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', install, { once: true });
    } else {
      install();
    }
  } catch (error) {
    // Stay inert.
  }
})();
